import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-main"
};
const _hoisted_4 = {
  class: "list-page-title"
};
const _hoisted_5 = {
  class: "list-page-description"
};
const _hoisted_6 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_7 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_8 = ["placeholder"];
const _hoisted_9 = ["disabled"];
const _hoisted_10 = ["disabled"];
const _hoisted_11 = {
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_12 = {
  class: "flex flex-wrap gap-2"
};
const _hoisted_13 = ["onClick"];
import { ref, reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import { getPlanPage, getPlanDetail } from '@/api/plan';
import ApprovalDetailModal from '@/components/ApprovalDetailModal.vue';
import CustomerDetailModal from '@/components/CustomerDetailModal.vue';
import CustomerSelector from '@/components/CustomerSelector/index.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import PlanDetailModal from '@/components/PlanDetailModal.vue';
import ProposalFormModal from '@/components/ProposalFormModal.vue';
import ProposalListTable from '@/components/ProposalListTable.vue';
export default {
  __name: 'ProposalManagement',
  setup(__props) {
    const uiText = {
      pageTitle: "方案管理",
      pageDescription: "管理规划师报价方案，包括创建、审批、跟踪等功能。",
      searchPlaceholder: "搜索方案编号、名称",
      allStatus: "全部状态",
      selectCustomer: "选择客户",
      createProposal: "新建方案",
      emptyDescription: "您可以创建一个新的报价方案来开始。",
      approvalDetail: "审批详情",
      proposalListError: "加载方案列表失败",
      proposalDetailError: "获取方案详情失败",
      approvalMissing: "该方案暂无审批实例"
    };
    const tabs = [{
      label: '\u5168\u90e8',
      value: ''
    }, {
      label: '\u5f85\u5ba1\u6279',
      value: 4
    }, {
      label: '\u6267\u884c\u4e2d',
      value: 1
    }, {
      label: '\u5df2\u5b8c\u6210',
      value: 2
    }, {
      label: '\u8349\u7a3f',
      value: 'draft'
    }, {
      label: '\u5df2\u53d6\u6d88',
      value: 3
    }];
    const statusOptions = [...tabs];
    const route = useRoute();
    const showEditModal = ref(false);
    const showDetailModal = ref(false);
    const showCustomerDetailModal = ref(false);
    const showApprovalDetailModal = ref(false);
    const selectedApprovalInstanceId = ref(null);
    const isEdit = ref(false);
    const editPlanData = ref(null);
    const planDetail = ref(null);
    const customerDetailData = ref(null);
    const loading = ref(false);
    const searchForm = reactive({
      keyword: '',
      customerId: '',
      status: ''
    });
    const pagination = reactive({
      current: 1,
      size: 10,
      total: 0,
      pages: 0
    });
    const planList = ref([]);
    const loadData = async () => {
      loading.value = true;
      try {
        const params = {
          keyword: searchForm.keyword || undefined,
          customerId: searchForm.customerId || undefined,
          page: pagination.current,
          size: pagination.size
        };
        if (searchForm.status === 'draft') {
          params.isDraft = 1;
        } else if (searchForm.status !== '') {
          params.status = searchForm.status;
        }
        const data = await getPlanPage(params);
        planList.value = data?.records || [];
        pagination.current = data?.current || 1;
        pagination.size = data?.size || pagination.size;
        pagination.total = data?.total || 0;
        pagination.pages = data?.pages || 0;
      } catch (error) {
        ElMessage.error(uiText.proposalListError);
      } finally {
        loading.value = false;
      }
    };
    const handleSearch = () => {
      pagination.current = 1;
      loadData();
    };
    const resetSearch = () => {
      searchForm.keyword = '';
      searchForm.customerId = '';
      searchForm.status = '';
      pagination.current = 1;
      loadData();
    };
    const handlePageChange = page => {
      if (page < 1 || page > pagination.pages) return;
      pagination.current = page;
      loadData();
    };
    const handlePageSizeChange = size => {
      pagination.size = size;
      pagination.current = 1;
      loadData();
    };
    const openCreateModal = () => {
      isEdit.value = false;
      editPlanData.value = null;
      showEditModal.value = true;
    };
    const openEditModal = plan => {
      isEdit.value = true;
      editPlanData.value = plan;
      showEditModal.value = true;
    };
    const openDetailModal = plan => {
      planDetail.value = plan;
      showDetailModal.value = true;
    };
    const openCustomerDetailModal = customer => {
      if (!customer?.id) return;
      customerDetailData.value = {
        id: customer.id,
        name: customer.name || ''
      };
      showCustomerDetailModal.value = true;
    };
    const openCustomerDetailFromPlan = plan => {
      if (!plan?.customerId) return;
      openCustomerDetailModal({
        id: plan.customerId,
        name: plan.customerName
      });
    };
    const openApprovalDetailModal = plan => {
      if (!plan?.approvalInstanceId) {
        ElMessage.warning(uiText.approvalMissing);
        return;
      }
      selectedApprovalInstanceId.value = plan.approvalInstanceId;
      showApprovalDetailModal.value = true;
    };
    onMounted(async () => {
      const {
        id,
        planId,
        keyword,
        customerId,
        status,
        create,
        openDetail
      } = route.query;
      const targetPlanId = id || planId;
      if (targetPlanId && openDetail === 'true') {
        try {
          const detail = await getPlanDetail(targetPlanId);
          if (detail) {
            planDetail.value = detail;
            showDetailModal.value = true;
          }
        } catch (error) {
          console.error('getPlanDetail failed:', error);
          ElMessage.error(uiText.proposalDetailError);
        }
        window.history.replaceState({}, '', '/proposal');
      } else if (targetPlanId) {
        searchForm.keyword = targetPlanId;
      }
      if (keyword) {
        searchForm.keyword = keyword;
      }
      if (customerId) {
        searchForm.customerId = customerId;
      }
      if (status !== undefined && status !== '') {
        searchForm.status = Number(status);
      }
      loadData();
      if (create === 'true') {
        openCreateModal();
        window.history.replaceState({}, '', '/proposal');
      }
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h1", _hoisted_4, _toDisplayString(uiText.pageTitle), 1), _createElementVNode("p", _hoisted_5, _toDisplayString(uiText.pageDescription), 1)])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": "",
          "refresh-loading": loading.value,
          onRefresh: loadData
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn-primary",
            onClick: openCreateModal
          }, [_cache[8] || (_cache[8] = _createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1)), _createTextVNode(" " + _toDisplayString(uiText.createProposal), 1)])), [[_directive_permission, 'plan:save']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: loading.value,
            onClick: handleSearch
          }, " 搜索 ", 8, _hoisted_9), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: loading.value,
            onClick: resetSearch
          }, " 重置 ", 8, _hoisted_10)]),
          extra: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, tab => {
            return _createElementVNode("button", {
              key: tab.value,
              class: _normalizeClass(['rounded-full px-3 py-1.5 text-sm font-medium transition-colors', searchForm.status === tab.value ? 'bg-primary-100 text-primary-700' : 'bg-slate-100 text-slate-600 hover:bg-slate-200']),
              onClick: $event => {
                searchForm.status = tab.value;
                handleSearch();
              }
            }, _toDisplayString(tab.label), 11, _hoisted_13);
          }), 64))])])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchForm.keyword = $event),
            type: "text",
            placeholder: uiText.searchPlaceholder,
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 40, _hoisted_8), [[_vModelText, searchForm.keyword]]), _cache[7] || (_cache[7] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: searchForm.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.status = $event),
            placeholder: uiText.allStatus,
            clearable: "",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleSearch
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, tab => {
              return _createVNode(_component_el_option, {
                key: tab.value,
                label: tab.label,
                value: tab.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue", "placeholder"]), _createVNode(CustomerSelector, {
            modelValue: searchForm.customerId,
            "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => searchForm.customerId = $event), handleSearch],
            placeholder: uiText.selectCustomer,
            class: "selector-compact filter-bar-field"
          }, null, 8, ["modelValue", "placeholder"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createVNode(ProposalListTable, {
          plans: planList.value,
          loading: loading.value,
          pagination: pagination,
          "empty-description": uiText.emptyDescription,
          onDetail: openDetailModal,
          onEdit: openEditModal,
          onApprovalDetail: openApprovalDetailModal,
          onCustomerClick: openCustomerDetailFromPlan,
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["plans", "loading", "pagination", "empty-description"])]), _createVNode(ProposalFormModal, {
          visible: showEditModal.value,
          "onUpdate:visible": _cache[3] || (_cache[3] = $event => showEditModal.value = $event),
          isEdit: isEdit.value,
          editData: editPlanData.value,
          onSuccess: loadData
        }, null, 8, ["visible", "isEdit", "editData"]), _createVNode(PlanDetailModal, {
          visible: showDetailModal.value,
          "onUpdate:visible": _cache[4] || (_cache[4] = $event => showDetailModal.value = $event),
          planData: planDetail.value
        }, null, 8, ["visible", "planData"]), _createVNode(ApprovalDetailModal, {
          modelValue: showApprovalDetailModal.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showApprovalDetailModal.value = $event),
          "instance-id": selectedApprovalInstanceId.value,
          type: "proposal",
          title: uiText.approvalDetail
        }, null, 8, ["modelValue", "instance-id", "title"]), _createVNode(CustomerDetailModal, {
          modelValue: showCustomerDetailModal.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => showCustomerDetailModal.value = $event),
          customer: customerDetailData.value,
          "visible-tabs": ['basic', 'proposals', 'orders']
        }, null, 8, ["modelValue", "customer"])]),
        _: 1
      });
    };
  }
};